import { useState, useRef, useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ChevronDown, Globe } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-3 py-2 border border-[#262626] hover:border-[#D4AF37] text-white font-body text-sm tracking-[0.15em] uppercase transition-colors"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe className="w-4 h-4 text-[#D4AF37]" />
        <span>{current.label}</span>
        <ChevronDown
          className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <ul
          data-testid="language-dropdown"
          className="absolute right-0 mt-2 w-32 bg-[#0f0f0f] border border-[#262626] py-1 z-50"
          role="listbox"
        >
          {languages.map((l) => (
            <li key={l.code}>
              <button
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                data-testid={`language-option-${l.code}`}
                className={`w-full text-left px-4 py-2.5 font-body text-sm uppercase tracking-[0.15em] transition-colors ${
                  l.code === lang
                    ? "bg-[#D4AF37]/10 text-[#D4AF37]"
                    : "text-white hover:bg-white/5 hover:text-[#D4AF37]"
                }`}
                role="option"
                aria-selected={l.code === lang}
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
